import React from 'react';
export function PrecioSection() {
  return <section className="bg-[#0F0F0F] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-id="element-103">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center space-y-12" data-id="element-104">
        <div className="space-y-4" data-id="element-105">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#FFFFFF]" data-id="element-106">
            Juega Desde Otro Nivel
          </h2>
          <p className="text-xl md:text-2xl text-[#FFFFFF] opacity-90" data-id="element-107">
            Intervención estratégica
            <br data-id="element-108" />
            90 minutos · Zoom en vivo
          </p>
        </div>

        <div className="py-8" data-id="element-109">
          <p className="text-7xl md:text-8xl lg:text-9xl font-bold text-[#C9A96E] tracking-tight" data-id="element-110">
            $15{' '}
            <span className="text-3xl md:text-4xl lg:text-5xl align-top" data-id="element-111">
              USD
            </span>
          </p>
        </div>

        <div className="space-y-8 w-full" data-id="element-112">
          <p className="text-xl md:text-2xl text-[#FFFFFF]" data-id="element-113">
            Menos que una comida.
            <br data-id="element-114" />
            Pero puede cambiar cómo crece tu negocio.
          </p>

          <button className="bg-[#C9A96E] text-[#0F0F0F] font-bold text-xl md:text-2xl py-5 px-12 rounded-full hover:opacity-90 transition-opacity w-full md:w-auto shadow-[0_0_30px_rgba(201,169,110,0.3)]" data-id="element-115">
            DESCUBRIR MI 20% CRÍTICO
          </button>
        </div>
      </div>
    </section>;
}